import { useNavigate } from 'react-router';
import styles from 'components/EventCard.module.css';
import Image from 'components/Image';
import { ImageOwnerType, ImageSize } from 'app-constants';
import { formatLocation, formatEventDateTime } from 'utils';

interface EventCardProps {
    event: {
        eventId: string;
        organizationId: string;
        title: string;
        startTime?: string | null;
        endTime?: string | null;
        location: string;
        description: string;
        imageId: string | null;
        tags: Array<string | null>;
        attendeeLimit?: number | null;
        maxGuests?: number | null;
        attendeeCount?: number | null;
    };
}

const EventCard: React.FC<EventCardProps> = ({ event }) => {
    const navigate = useNavigate();
    return (
        <div className={styles.eventCard} onClick={() => navigate(`/events/${event.eventId}`)}>
            <Image imageOwnerType={ImageOwnerType.Organization} imageSize={ImageSize.Card} imageId={event.imageId} />
            <h3>{event.title}</h3>
            <p>{formatEventDateTime(event.startTime || '', event.endTime || '', true)}</p>
            <p>{formatLocation(event.location)}</p>
            <p>{event.attendeeCount} attending</p>
        </div>
    );
};
export default EventCard;